//images
import canned from "./components/images/canned.jfif";
import dairy from "./components/images/dairy.jfif";
import meat from "./components/images/meat.jfif";
import processed from "./components/images/processed.jfif";
import bakery from "./components/images/bakery.jfif";
import snacks from "./components/images/snacks.jfif";
import condiments from "./components/images/condiments.jfif";
import beverages from "./components/images/beverages.jfif";
import vegetables from "./components/images/vegetables.jfif";
import cart from "./components/images/shopping-cart.png";
import spices from "./components/images/spices.jfif";
import newArrival from "./components/images/new arrival.png";
import topSeller from "./components/images/top-seller.png";
import fifteen from "./components/images/fifteen.png";
import priceDrops from "./components/images/priceDrops.png";

export default function homeCategories() {
  const categories = [
    {
      name: "Newest Items",
      image: newArrival,
      url: "/products/?newest=true",
    },
    {
      name: "Price Drops",
      image: priceDrops, // You can replace this with a custom price drop image
      url: "/products/?priceDrops=true",
    },
    {
      name: "$15 or less",
      image: fifteen,
      url: "/products/?lessThan=1500&sort=price_low",
    },
    {
      name: "Top Sellers",
      image: topSeller,
      url: "/products/?popular=TRUE",
    },
    {
      name: "Dairy",
      image: dairy,
      url: "/products/?category=DAIRY",
    },
    {
      name: "Meat & Seafood",
      image: meat,
      url: `/products/?category=${encodeURIComponent("MEAT & SEAFOOD")}`,
    },
    {
      name: "Prepared Foods",
      image: processed,
      url: "/products/?category=ENTREE",
    },
    {
      name: "Bread, Rolls & Bakery",
      image: bakery,
      url: "/products/?category=BAKERY",
    },
    {
      name: "Snacks, Chips, Candy",
      image: snacks,
      url: "/products/?category=SNACKS",
    },
    {
      name: "Pantry",
      image: spices,
      url: "/products/?category=PANTRY",
    },
    {
      name: "Condiments",
      image: condiments,
      url: "/products/?category=CONDIMENTS",
    },
    {
      name: "Beverages",
      image: beverages,
      url: "/products/?category=BEVERAGE",
    },
    {
      name: "Vegetables",
      image: vegetables,
      url: "/products/?category=VEGETABLES",
    },
    {
      name: "Canned Goods",
      image: canned,
      url: "/products/?category=CANNED GOODS",
    },
    {
      name: "All Items",
      image: cart,
      url: "/products/",
    },
  ];
  return categories;
}
